import React from 'react';
import { AttraqtSuggestionsCategory } from '../../../../../../../types';

export interface PopularCategoriesProps {
  popularProducts: AttraqtSuggestionsCategory[];
}

function PopularCategories({ popularProducts }: PopularCategoriesProps): React.ReactElement {
  return (
    <div>
      {popularProducts.map(({ location, code, name }) => (
        <a key={code} href={location as string} className="search-suggestion__link">
          {name}
        </a>
      ))}
    </div>
  );
}

export default PopularCategories;
